export const HOME_PATH = '/';
export const MEDIAS_PATH = '/photos.html';
export const FAQ_PATH = '/faq.html';
export const SUPPLIER_PATH = '/nos-fournisseurs.html';
export const LEGAL_NOTICES_PATH = '/mentions-legales.html';
export const TERMS_OF_USE_PATH = '/cgu.html';
export const LOGIN_PATH = '/login.html';
export const PARAMETERS_PATH = '/parametres.html';
export const TICKETS_PATH = '/mes-demandes.html';
export const HELP_PATH = '/aide.html';
export const UPDATE_PASSWORD_REQUEST_PATH =  '/demande-de-mise-a-jour-du-mot-de-passe.html';
export const UPDATE_PASSWORD_PATH =  '/mise-a-jour-du-mot-de-passe.html';